import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class StickyAddToCart extends HTMLElement {
  #unsubscribe;

  connectedCallback() {
    this.#observeProductForm();

    this.#unsubscribe = PubSub.subscribe('variant:change', ({ id, data: { html } }) => {
      if (id !== this.dataset.productId) return;
      this.#handleVariantChange(html);
      this.#observeProductForm();
    });
  }

  disconnectedCallback() {
    this.#unsubscribe();
  }

  /**
   * Handle variant changes.
   * @param {HTMLElement} html - The HTML to render.
   */
  #handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  /**
   * Observe the product form.
   */
  #observeProductForm() {
    const productForm = document.querySelector('product-form');

    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      this.classList.toggle('translate-y-0', !isIntersecting);
      this.classList.toggle('translate-y-full', isIntersecting);
      this.classList.toggle('opacity-0', isIntersecting);
    });

    observer.observe(productForm);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
